module.exports = __webpack_public_path__ + "img/360-matsal-old.8fc81b4d.jpg";